(ns renolit-roofing-service.websocket
  (:require [renolit-roofing-service.websocket.message-handler :as ws.msg-handler]
            [re-frame.core :as rf]
            [taoensso.encore :as enc]
            [taoensso.sente :as sente]))

(defonce websocket-chsk (atom nil))

(def ws-kalive-ms
  "By default the Sente WebSockets keep alive is done every 20
  seconds. We are just making that setting explicit here.

  NOTE: if you want to change this, bear in mind that it should be
  different from the one in the server."
  (enc/ms :secs 20))

(def csrf-token
  (atom nil))

(def ^:const default-chsk-opts
  {:type :auto
   :packer :edn
   :wrap-recv-evs? false
   :ws-kalive-ms ws-kalive-ms})

(rf/reg-fx
 ::update-csrf-token
 (fn [id-token]
   (reset! csrf-token id-token)))

(rf/reg-event-fx
 ::session-token-refreshed
 [(rf/inject-cofx :session)]
 (fn [{:keys [session]} [_ _]]
   {:fx [[::update-csrf-token (:jwt-token session)]]}))

(defn- csrf-token-fn
  []
  (deref csrf-token))

(defn- make-websocket-chsk!
  [id-token]
  (reset! csrf-token id-token)
  (if-let [{:keys [ch-recv] :as chsk}
           (sente/make-channel-socket-client! "/api/chsk"
                                              ;; Use the `id-token` for the CSRF token.
                                              ;; See ADR `docs/arch/adr-001.md` for the reasons why we do this.
                                              csrf-token-fn
                                              default-chsk-opts)]
    (do
      (reset! websocket-chsk chsk)
      (sente/start-client-chsk-router! ch-recv #'ws.msg-handler/handle-message))
    (throw (ex-info "Could not open WebSockets channel socket!" {}))))

#_{:clj-kondo/ignore [:redundant-fn-wrapper]}
(rf/reg-fx
 :make-websocket-chsk
 (fn [id-token]
   (make-websocket-chsk! id-token)))
